import styled from "styled-components";

export const CardGroupContainer = styled.div`
  background-color: #93a4bd;
  div {
    display: flex;
    justify-content: space-around;
    padding: 1.5rem 0;
  }

  @media (max-width: 855px) {
    div {
      flex-direction: column;
    }
  }
`;
